export const BORDER_RADIUS = '6px';

export const BASE_COLORS = {
	white: '#ffffff',
	black: '#1E1E1E',
	green: '#009346',
	greenLight: '#80C9A2',
	greenUltraLight: '#EFFFF6',
	red: '#ff5252',
	redLight: '#efaeae',
	redUltraLight: '#ffd8d8',
	orange: '#ffb155',
	orangeLight: '#f6cca1',
	blue: '#001EB9',
	blueLight: '#566dd0',
	gray: '#878787',
	grayLight: '#D9D9D9',
	grayUltraLight: '#F7F7F7',
};

export const LAYOUT = {
	mobile: {
		paddingVertical: '0.75rem',
		paddingHorizontal: '1rem',
		headerHeight: '4.25rem',
		headerPadding: '1rem',
	},
	desktop: {
		paddingVertical: '1.25rem',
		paddingHorizontal: '2.25rem',
		headerHeight: '5.625rem',
	},
};

export const FONT_SIZE = {
	xxs: '0.75rem',
	xs: '0.875rem',
	md: '1rem', // 16
	lg: '1.125rem', // 18
	xl: '1.25rem', // 20
	xxl: '1.5rem', // 24
	xxxl: '1.625rem',
	xxxxl: '2rem',
};

export const FONT_WEIGHT = {
	thin: '100',
	extraLight: '200',
	light: '300',
	regular: '400',
	medium: '500',
	semibold: '600',
	bold: '700',
	extraBold: '800',
	black: '900',
};

export const BREAKPOINTS = {
	xs: 360,
	sm: 568,
	md: 768,
	lg: 992,
	xl: 1280,
	xxl: 1920,
} as const;

const getMedia = <T extends number>(breakpoint: T): `(min-width: ${T}px)` =>
	`(min-width: ${breakpoint}px)`;

export const media = {
	xs: getMedia(BREAKPOINTS.xs),
	sm: getMedia(BREAKPOINTS.sm),
	md: getMedia(BREAKPOINTS.md),
	lg: getMedia(BREAKPOINTS.lg),
	xl: getMedia(BREAKPOINTS.xl),
	xxl: getMedia(BREAKPOINTS.xxl),
};
